export default {
  table: {
    width: "100%",
    marginBottom: "var(--rhythm)",
    tableLayout: "fixed",
    borderCollapse: "collapse",
    color: "var(--color-black)",
    fontSize: "var(--font-size-s)",
    caption: {
      marginBottom: "calc(1 * var(--rhythm))",
      fontSize: "var(--font-size-m)",
      fontWeight: "bold",
      textAlign: "left",
      color: "var(--color-blue)",
    },
    tr: {
      height: "calc(1.5 * var(--rhythm))",
      verticalAlign: "middle",
      borderBottom: "1px solid var(--color-blue)",
    },
    th: {
      textAlign: "center",
      "&:first-of-type": {
        maxWidth: "100px",
      },
    },
    td: {
      textAlign: "center",
    },
    strong: {
      display: "inline-flex",
      alignItems: "flex-start",
      fontWeight: "bold",
    },
    svg: {
      marginTop: "3px",
      marginLeft: "5px",
    },
  },
};
